import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';
import { IRawFormConfig, IFormConfig } from 'js/components/common/Form/types';

export const parseForms = (forms: IRawFormConfig[] = []): IFormConfig[] => forms.map(form => {
    const formSteps = (form.form.formSteps || []).map(formStep => {
        return formStep.map(field => {
            if (field.type === FORM_FIELD_TYPE.PLACE_OF_BIRTH) {
                return {
                    ...field,
                    innerFields: {
                        ...field.innerFields,
                        dateOfBirth: { ...field.innerFields.dateOfBirth, active: true },
                        countryOfBirth: { ...field.innerFields.countryOfBirth, active: true }
                    }
                };
            }

            if (field.type === FORM_FIELD_TYPE.PLACE_OF_RESIDENCE) {
                return {
                    ...field,
                    innerFields: {
                        ...field.innerFields,
                        countryOfResidence: { ...field.innerFields.countryOfResidence, active: true }
                    }
                };
            }

            return field;
        });
    });

    return {
        ...form.form,
        id: form.id,
        name: form.name,
        formSteps,
        formRules: form.form.formRules || []
    };
});
